import { motion } from 'framer-motion'
import styled from 'styled-components'

export const EditionModalContainerStyles = styled(motion.div)``
